import { render, staticRenderFns } from "./bannerCenter.vue?vue&type=template&id=3ee1f7dd&scoped=true&"
import script from "./bannerCenter.vue?vue&type=script&lang=js&"
export * from "./bannerCenter.vue?vue&type=script&lang=js&"
import style0 from "./bannerCenter.vue?vue&type=style&index=0&id=3ee1f7dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1f7dd",
  null
  
)

export default component.exports